import { Injectable } from '@angular/core';
import Discussion from '../interfaces/Discussion';
import Comment from '../interfaces/Comment';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';
import { from, combineLatest, Observable, BehaviorSubject, Subscription } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class ForumService {
  userDiscussions$ = new BehaviorSubject([]);
  allDiscussions;
  allMembers;
  allComments;

  constructor(private afs: AngularFirestore, private userService: UserService) {
    //this.updateComments();
  }

  updateComments() {
    this.userService.user.subscribe((u) => {
      if (u && u.uid && u.email === 'nathan@niftic.agency') {
        var updateDiscussions = confirm('Update discussion comments?');
        if (updateDiscussions) {

          this.getAllComments().subscribe((comments) => {
            if (comments) {
              this.allComments = comments;


              this.getAllDiscussions().subscribe((discussions) => {
                if (discussions) {
                  this.allDiscussions = discussions;
                  console.log(this.allDiscussions);

                  this.userService.getMembers().subscribe((members) => {
                    if (members) {
                      this.allMembers = members

                      // // delete current discussion comment data
                      // this.allDiscussions.forEach((d) => {
                      //   d.comments = []
                      //   this.updateDiscussion(d.id, d)
                      // })


                      // // delete current member comment data
                      // this.allMembers.forEach((m) => {
                      //   m.comments = []
                      //   this.userService.saveUser(m.uid, m);
                      // });

                      // // delete any orphan replies
                      // this.allComments.forEach((comment) => {
                      //   if (comment.replyTo && comment.replyTo.length) {
                      //     if (
                      //       !this.allComments.some((c) => comment.replyTo === c.id) ||
                      //       !this.allDiscussions.some((d) => comment.discussion === d.id) 
                      //     ) {
                      //       console.log(comment);
                      //       this.deleteComment(comment.id)
                      //     }
                      //   }
                      // })


                      this.allDiscussions.forEach((d) => {
                        this.allComments.forEach((c) => {
                          if (c.discussion === d.id) {
                            this.allMembers.forEach((m) => {
                              if (c.owner === m.uid) {

                                // update discussion comment data
                                d.comments.push({
                                  id: c.id,
                                  uid: m.uid,
                                  name: m.displayName,
                                  profilePicture: m.profilePicture
                                })
                                this.updateDiscussion(d.id, d);

                                // update member comment data
                                m.comments.push(c.id)
                                this.userService.saveUser(m.uid, m)
                              }
                            })
                          }
                        })
                      })

                    
                    }
                  })
                }
              })
            }
          })
        }
      }
    })
  }

  createDiscussion(d: Discussion) {
    return new Promise((resolve, reject) => {
      this.afs
        .collection('discussions')
        .add(d)
        .then((dRef) => {
          dRef.update({ id: dRef.id }).then(() => {
            resolve(dRef.id);
          });
        })
        .catch((e) => reject(e));
    });
  }

  updateDiscussion(dId, d) {
    const discussionRef: AngularFirestoreDocument<any> = this.afs.doc(`/discussions/${dId}`);
    return discussionRef.update(d);
  }

  getDiscussion(id) {
    return new Promise((resolve, reject) => {
      const discussionRef: AngularFirestoreDocument<any> = this.afs.doc(`discussions/${id}`);
      discussionRef.get().subscribe(
        (ds) => {
          resolve(ds.data());
        },
        (e) => reject(e)
      );
    });
  }
  getComment(id) {
    return new Promise((resolve, reject) => {
      const commentRef: AngularFirestoreDocument<any> = this.afs.doc(`comments/${id}`);
      commentRef.get().subscribe(
        (ds) => {
          resolve(ds.data());
        },
        (e) => reject(e)
      );
    });
  }

  getDiscussions(limit): Observable<Array<Discussion>> {
    const discussionsRef: AngularFirestoreCollection<any> = this.afs.collection('discussions', (ref) =>
      ref.orderBy('timestamp', 'desc').limit(limit)
    );
    // return from(discussionsRef.valueChanges().pipe(take(1)));
    return discussionsRef.get().pipe(
      map((d) => {
        return d.docs.map((doc) => {
          return doc.data() as Discussion;
        });
      })
    );
  }

  getDiscussionsByApproach(approach, limit) {
    const discussionsRef: AngularFirestoreCollection<any> = this.afs.collection('discussions', (ref) =>
      ref.where('approaches', 'array-contains', approach).orderBy('timestamp', 'desc').limit(limit)
    );
    return from(discussionsRef.valueChanges().pipe(take(1)));
  }

  getAllDiscussions() {
    const discussionsRef: AngularFirestoreCollection<any> = this.afs.collection('discussions', (ref) =>
      ref.orderBy('timestamp', 'desc')
    );
    return from(discussionsRef.valueChanges().pipe(take(1)));
  }

  getTestDiscussions(limit) {
    const discussionsRef: AngularFirestoreCollection<any> = this.afs.collection('test-discussions', (ref) =>
      ref.orderBy('timestamp', 'desc').limit(limit)
    );
    return discussionsRef.valueChanges().pipe(take(1));
  }

  getAllTestDiscussions() {
    const discussionsRefAll: AngularFirestoreCollection<any> = this.afs.collection('test-discussions', (ref) =>
      ref.orderBy('timestamp', 'desc')
    );
    return discussionsRefAll.valueChanges().pipe(take(1));
  }

  getUserDiscussions(uid) {
    this.userDiscussions$.next([
      from(
        this.afs
          .collection('discussions', (ref) => ref.where('owner', '==', uid))
          .valueChanges()
          .pipe(take(1))
      ),
      from(this.afs.collection('comments', (ref) => ref.where('owner', '==', uid).orderBy('timestamp')).valueChanges()),
    ]);
    return this.userDiscussions$;
  }

  getResourceDiscussions(id) {
    return from(
      this.afs
        .collection('discussions', (ref) => ref.where('resource', '==', id))
        .valueChanges()
        .pipe(take(1))
    );
  }
  deleteDiscussion(id) {
    const commentRef: AngularFirestoreDocument<any> = this.afs.doc(`/discussions/${id}`);
    return commentRef.delete();
  }

  getComments(discussionId) {
    return from(
      this.afs
        .collection('comments', (ref) => ref.where('discussion', '==', discussionId).orderBy('timestamp'))
        .valueChanges()
    );
  }
  getAllComments() {
    const commentsRef: AngularFirestoreCollection<any> = this.afs.collection('comments', (ref) =>
      ref.orderBy('timestamp', 'desc')
    );
    return from(commentsRef.valueChanges().pipe(take(1)));
  }

  updateComment(cId, d) {
    const commentRef: AngularFirestoreDocument<any> = this.afs.doc(`/comments/${cId}`);
    return commentRef.update(d);
  }

  postComment(c: Comment) {
    return new Promise((resolve, reject) => {
      this.afs
        .collection('comments')
        .add(c)
        .then((cRef) => {
          cRef.update({ id: cRef.id }).then(() => {
            resolve(cRef);
          });
        })
        .catch((e) => reject(e));
    });
  }

  deleteComment(id) {
    const commentRef: AngularFirestoreDocument<any> = this.afs.doc(`/comments/${id}`);
    return commentRef.delete();
  }

  getCurrentUserOwnedDiscussions(uid) {
    const userDiscussionsRef: AngularFirestoreCollection<any> = this.afs.collection('discussions', (ref) =>
      ref.where('owner', '==', uid)
    );
    return from(userDiscussionsRef.valueChanges());
  }
}
